import { get_ONEazvfdh9ju3d4 as get_ONE } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/boxedLong/boxedLong.mjs';
import {
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
  convertToInty04h231mmjoh as convertToInt,
  negate13xrbakfwasjy as negate,
  dividelr0uqtdj497z as divide,
  fromInt2ii0rejb1w62w as fromInt,
  modulooi4g1kq3dmtt as modulo,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  safeMultiply1xb0xo3cufzd3 as safeMultiply,
  safeAdd2ojtf0puot5k0 as safeAdd,
} from './mathNative.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  ArithmeticException18dajwq7kbp38 as ArithmeticException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { removePrefix279df90bhrqqg as removePrefix } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { longRangeToLong1wnzlyc7cu6kp as longRangeToLong } from '../../../../kotlin-kotlin-stdlib/kotlin/js/rangeTo.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_POWERS_OF_TEN() {
  _init_properties_math_kt__tgcmt4();
  return POWERS_OF_TEN;
}
var POWERS_OF_TEN;
function multiplyAndAdd(d, n, r) {
  _init_properties_math_kt__tgcmt4();
  var md = d;
  var mr = r;
  if (d > 0n && r < 0n) {
    var _unary__edvuaz = md;
    md = subtract(_unary__edvuaz, get_ONE());
    mr = add(mr, n);
  } else if (d < 0n && r > 0n) {
    var _unary__edvuaz_0 = md;
    md = add(_unary__edvuaz_0, get_ONE());
    mr = subtract(mr, n);
  }
  return safeAdd(safeMultiply(md, n), mr);
}
var DecimalFractionClass;
function DecimalFraction() {
  if (DecimalFractionClass === VOID) {
    class $ {
      constructor(fractionalPart, digits) {
        this.fractionalPart_1 = fractionalPart;
        this.digits_1 = digits;
        // Inline function 'kotlin.require' call
        if (!(this.digits_1 >= 0)) {
          var message = 'Digits must be non-negative, but was ' + this.digits_1;
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
      }
      fractionalPartWithNDigits_sivm3u_k$(newDigits) {
        return newDigits === this.digits_1 ? this.fractionalPart_1 : newDigits > this.digits_1 ? imul(this.fractionalPart_1, get_POWERS_OF_TEN()[newDigits - this.digits_1 | 0]) : this.fractionalPart_1 / get_POWERS_OF_TEN()[this.digits_1 - newDigits | 0] | 0;
      }
      compareTo_am6p9g_k$(other) {
        var tmp0 = this.digits_1;
        // Inline function 'kotlin.comparisons.maxOf' call
        var b = other.digits_1;
        // Inline function 'kotlin.let' call
        var maxPrecision = Math.max(tmp0, b);
        return compareTo(this.fractionalPartWithNDigits_sivm3u_k$(maxPrecision), other.fractionalPartWithNDigits_sivm3u_k$(maxPrecision));
      }
      compareTo_hpufkf_k$(other) {
        return this.compareTo_am6p9g_k$(other instanceof DecimalFraction() ? other : THROW_CCE());
      }
      equals(other) {
        var tmp;
        if (other instanceof DecimalFraction()) {
          tmp = this.compareTo_am6p9g_k$(other) === 0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      toString() {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
        var denominator = get_POWERS_OF_TEN()[this.digits_1];
        this_0.append_uppzia_k$(this.fractionalPart_1 / denominator | 0);
        this_0.append_58al37_k$(_Char___init__impl__6a9atx(46));
        this_0.append_22ad7x_k$(removePrefix((denominator + (this.fractionalPart_1 % denominator | 0) | 0).toString(), '1'));
        return this_0.toString();
      }
      hashCode() {
        throw UnsupportedOperationException().new_kotlin_UnsupportedOperationException_chzcdl_k$('DecimalFraction is not supposed to be used as a hash key');
      }
    }
    initMetadataForClass($, 'DecimalFraction', VOID, VOID, [Comparable()]);
    DecimalFractionClass = $;
  }
  return DecimalFractionClass;
}
function clampToInt(_this__u8e3s4) {
  _init_properties_math_kt__tgcmt4();
  return _this__u8e3s4 > 2147483647n ? 2147483647 : _this__u8e3s4 < -2147483648n ? -2147483648 : convertToInt(_this__u8e3s4);
}
function get_sizeUnsafe(_this__u8e3s4) {
  _init_properties_math_kt__tgcmt4();
  var tmp;
  if (_this__u8e3s4.isEmpty_y1axqb_k$()) {
    tmp = 0;
  } else {
    var tmp_0;
    try {
      // Inline function 'kotlin.Long.plus' call
      var this_0 = divide(safeAdd(_this__u8e3s4.last_1, negate(_this__u8e3s4.first_1)), _this__u8e3s4.step_1);
      var tmp$ret$0 = add(this_0, fromInt(1));
      tmp_0 = clampToInt(tmp$ret$0);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof ArithmeticException()) {
        var e = $p;
        tmp_1 = 2147483647;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function containsUnsafe(_this__u8e3s4, value) {
  _init_properties_math_kt__tgcmt4();
  var tmp;
  var progression = _this__u8e3s4.step_1 > 0n ? longRangeToLong(_this__u8e3s4.first_1, _this__u8e3s4.last_1) : longRangeToLong(_this__u8e3s4.last_1, _this__u8e3s4.first_1);
  var containsLower = progression.first_1;
  if (value <= progression.last_1 ? containsLower <= value : false) {
    tmp = modulo(subtract(value, _this__u8e3s4.first_1), _this__u8e3s4.step_1) === 0n;
  } else {
    tmp = false;
  }
  return tmp;
}
var properties_initialized_math_kt_amm9wq;
function _init_properties_math_kt__tgcmt4() {
  if (!properties_initialized_math_kt_amm9wq) {
    properties_initialized_math_kt_amm9wq = true;
    // Inline function 'kotlin.intArrayOf' call
    POWERS_OF_TEN = new Int32Array([1, 10, 100, 1000, 10000, 100000, 1000000, 10000000, 100000000, 1000000000]);
  }
}
//region block: exports
export {
  DecimalFraction as DecimalFraction15n0off36xuu9,
  get_POWERS_OF_TEN as get_POWERS_OF_TEN1o6pqgdjh70q1,
  clampToInt as clampToInt3i2uwu7s275hw,
  containsUnsafe as containsUnsafe3ldznmwv9m694,
  multiplyAndAdd as multiplyAndAdd2gfolze8k1tuw,
  get_sizeUnsafe as get_sizeUnsafe34uncbw86p6vc,
};
//endregion

//# sourceMappingURL=math.mjs.map
